import type { SwitchProps } from 'antd';
import { Switch } from 'antd';
import styled, { css } from 'styled-components';

export const BASE_SWITCH_STYLES = css`
    button[role='switch'] {
        .ant-switch-handle::before {
            background: var(--colors-surface-primary, #fff) !important;
        }
    }

    button[role='switch'][aria-checked='false'] {
        background: var(--colors-surface-primary, #fff) !important;
        border: var(--border-width-sm_1, 1px) solid var(--colors-border-action, #2171c6);
        border-radius: var(--border-radius-round, 48px);

        .ant-switch-handle {
            top: 2px;
            left: 3px;
        }

        .ant-switch-handle::before {
            background: var(--colors-surface-action, #2171c6) !important;
        }
    }

    button[role='switch'][aria-checked='true'] {
        background: var(--colors-surface-action, #2171c6) !important;
    }
`;

const StyledSwitch = styled((props: SwitchProps) => <Switch {...props} />)``;

export default StyledSwitch;
